import React from 'react';
import { POLYGON_TYPE_LOT } from '../../util/constants';
function PopupClickContent({ lotContent, pinContent, polygonType }) {
    return polygonType === POLYGON_TYPE_LOT ? (lotContent) : (React.createElement("div", { className: "popup__click-content" }, pinContent));
}
export default React.memo(PopupClickContent);
